import { render, staticRenderFns } from "./StatCenter.vue?vue&type=template&id=4c0ce50e&scoped=true"
import script from "./StatCenter.vue?vue&type=script&lang=js"
export * from "./StatCenter.vue?vue&type=script&lang=js"
import style0 from "./StatCenter.vue?vue&type=style&index=0&id=4c0ce50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ce50e",
  null
  
)

export default component.exports